import React from "react";
import { Row, Col } from "react-bootstrap";
import { Content, Main } from "../../../components/Layout";
import style from "../style.module.css";

export default function VinculoEncerrado() {
  return (
    <Main className={style.mainUser}>
      <Content>
        <Row>
          <Col className="text-center">
            <h2 className="page-title mb-2">Vínculo Encerrado</h2>
            <p className="m-0">Seu vínculo com a instituição foi encerrado.</p>
            <p className="m-0">Entre em contato com a nossa equipe caso tenha dúvidas sobre a sua situação.</p>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
